import { Box, Chip, Typography } from '@mui/material';

export const DemReconAIInsights = () => {

  const data = {
  chips: ['702 no discrepancy', '47 reconciled', '41 outstanding', 'Unresolved $2.63M'],
  oneLineSummary:
    'Discrepancies are down 90% vs the 3-month average, with $2.63M unresolved — concentrated in ADAP, SUPP, and MEDI.',
  bulletPoints: [
    'Total discrepancy dollars are $13.9M (−90% vs 3-month average); unresolved dollars are $2.63M; matching is 94.8% for 2025M12.',
    'Outstanding dollars are concentrated in ADAP (~$1.07M), SUPP (~$1.02M), and MEDI (~$0.41M), with smaller residuals in Returns (~$0.12M), PHS (~$0.006M), and SPAP (~$0.002M); none in US Gross Sales, FSS, or NPVS.',
    'Primary resolved drivers include product mapping fixes (new + discontinued totaling ~$11.21M) and RCM interface timing (~$25K), leaving a narrower set of issues focused in a few channels.'
  ],
  fullSummary:
    'The waterfall indicates the largest reductions came from resolving product mapping issues—new and discontinued combined (~$11.21M)—with additional improvement from RCM interface timing corrections (~$25K). From a trend perspective, categories such as SUPP and MEDI were elevated earlier in 2025, while the current month’s unresolved position is materially smaller and concentrated in those same channels. Overall, the discrepancy footprint has contracted substantially, with closure now dependent on burning down the remaining ADAP, SUPP, and MEDI balances.'
};

  return (
    <>
      {/* KPI chips */}
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mb: 1.5 }}>
        {data.chips.map(chip =>
          <Chip
            key={chip}
            label={chip}
            variant="filled"
            sx={{ bgcolor: 'rgba(255,255,255,0.16)', color: 'inherit' }}
          />
        )}
      </Box>

      {/* TL;DR */}
      <Typography variant="subtitle1" sx={{ mb: 1 }}>
        {data.oneLineSummary}
      </Typography>

      {/* Bulleted highlights */}
      <Box component="ul" sx={{ pl: 2.5, mt: 0, mb: 1.5, '& li': { mb: 0.5 } }}>
        {data.bulletPoints.map((bulletPoint, index) =>
          <li key={index}>
            <Typography variant="body2">
              {bulletPoint}
            </Typography>
          </li>
        )}
      </Box>

      {/* Original narrative (narrow measure for readability) */}
      <Typography variant="body2" sx={{ lineHeight: 1.25 }}>
        {data.fullSummary}
      </Typography>

      {/* Micro-CTAs */}
      {/* <Box sx={{ display: 'flex', gap: 1.25, mt: 'auto', pt: 2 }}>
              <Button
                variant="contained"
                size="small"
                startIcon={<i className={fas.faBug} />}
                onClick={() => {
                  // example: open a filtered view for outliers
                  // setStartPeriod(...); setEndPeriod(...); setProdIds([...]);
                }}
              >
                View Outliers
              </Button>
              <Button
                variant="outlined"
                size="small"
                startIcon={<i className={fas.faLightbulb} />}
                onClick={() => {
                  // example: navigate to driver drilldown
                }}
                sx={{ color: 'inherit', borderColor: 'rgba(255,255,255,0.35)' }}
              >
                Driver Drilldown
              </Button>
            </Box> */}
    </>
  )
}